import { Component } from '@angular/core';

@Component({
    selector: 'ts-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
    standalone: false
})
export class PageNotFoundComponent { }
